import {inlineError} from '@s-ui/decorators'
import {Service} from '@s-ui/domain'

export class GetAdDetailsAdsService extends Service {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Object<Repository>} deps.repository
   */
  constructor({config, getCurrentUserService, log, repository}) {
    super()

    this._config = config
    this._getCurrentUserService = getCurrentUserService
    this._log = log
    this._repository = repository
  }

  _getCurrentUser = async () => {
    const currentUser = await this._getCurrentUserService.execute()
    return (currentUser && currentUser.getId()) || null
  }

  /**
   * @param {Number} adId
   * @param {Boolean} isPreview
   * @return {Promise<AdDetailsAggregate, Error>}
   */
  @inlineError
  async execute({adId, isPreview = false, expand}) {
    const userId = isPreview ? await this._getCurrentUser() : null

    const [getAdDetailsError, getAdDetailsResponse] = await this._repository.getAdDetails({
      adId,
      expand,
      isPreview,
      userId
    })

    if (getAdDetailsError) return Promise.reject(getAdDetailsError)

    return getAdDetailsResponse
  }
}
